import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCategoryOpen, setMobileCategoryOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur-md">
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <a href="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950 tracking-tight">
              Sugargoo<span className="text-primary-500">Spreadsheet</span>
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            <a href="/" className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors rounded-lg whitespace-nowrap cursor-pointer">
              <i className="ri-home-line mr-1.5"></i>Home
            </a>
            <a href="#categories" className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors rounded-lg whitespace-nowrap cursor-pointer">
              Categories
            </a>
            <a href="#what-is" className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors rounded-lg whitespace-nowrap cursor-pointer">
              About
            </a>
            <a href="#guides" className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors rounded-lg whitespace-nowrap cursor-pointer">
              Guides
            </a>
            <a href="#review" className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors rounded-lg whitespace-nowrap cursor-pointer">
              Reviews
            </a>
            <a href="#shipping" className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors rounded-lg whitespace-nowrap cursor-pointer">
              Shipping
            </a>
            <a
              href="/article/best-sugargoo-spreadsheet-2026"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors rounded-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-guide-line mr-1.5"></i>Shopping Guide
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="ml-2 px-5 py-2.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/70 max-h-[70vh] overflow-y-auto">
            <div className="flex flex-col gap-0.5 pt-3">
              <a href="/" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                <i className="ri-home-line text-base"></i>Home
              </a>

              <button
                onClick={() => setMobileCategoryOpen(!mobileCategoryOpen)}
                className="flex items-center justify-between w-full px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer"
              >
                <span className="flex items-center gap-2">
                  <i className="ri-grid-line text-base"></i>Product Categories
                </span>
                <i className={`text-base transition-transform ${mobileCategoryOpen ? 'rotate-180' : ''} ri-arrow-down-s-line`}></i>
              </button>

              {mobileCategoryOpen && (
                <div className="ml-4 pl-3 border-l-2 border-background-200/70">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setMobileOpen(false)}
                      className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer"
                    >
                      <i className={`${cat.icon} text-sm w-5 h-5 flex items-center justify-center`}></i>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}

              <a href="#what-is" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                <i className="ri-information-line text-base"></i>About
              </a>
              <a href="#guides" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                <i className="ri-book-open-line text-base"></i>Guides
              </a>
              <a href="#review" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                <i className="ri-star-line text-base"></i>Reviews
              </a>
              <a href="#shipping" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                <i className="ri-ship-line text-base"></i>Shipping
              </a>
              <a href="/article/best-sugargoo-spreadsheet-2026" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                <i className="ri-guide-line text-base"></i>Shopping Guide
              </a>

              <div className="border-t border-background-200/70 mt-2 pt-2">
                <p className="px-4 py-1.5 text-xs font-semibold text-foreground-400 uppercase tracking-wider">SEO Articles</p>
                <a href="/article/what-is-sugargoo-spreadsheet" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-600 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-article-line text-sm"></i>What Is Sugargoo Spreadsheet
                </a>
                <a href="/article/sugargoo-review-2026" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-600 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-star-line text-sm"></i>Sugargoo Review 2026
                </a>
                <a href="/article/sugargoo-shipping-cost" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-600 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-ship-line text-sm"></i>Shipping Cost Guide
                </a>
                <a href="/article/sugargoo-coupon-discount" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-600 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-coupon-line text-sm"></i>Coupon & Discount
                </a>
                <a href="/article/is-sugargoo-legit-safe" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-600 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-shield-check-line text-sm"></i>Is Sugargoo Legit
                </a>
                <a href="/article/sugargoo-warehouse-guide" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-600 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-building-line text-sm"></i>Warehouse Guide
                </a>
                <a href="/article/best-sugargoo-spreadsheet-2026" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-600 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-medal-line text-sm"></i>Best Spreadsheet 2026
                </a>
              </div>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="mx-4 mt-3 px-5 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}